import { useMemo } from 'react'
import { Capacitor } from '@capacitor/core'

export interface PlatformInfo {
  isIOS: boolean
  isAndroid: boolean
  isWeb: boolean
  isNative: boolean
  platform: string
}

export function usePlatform(): PlatformInfo {
  return useMemo(() => {
    const platformName = Capacitor.getPlatform()
    const isNative = Capacitor.isNativePlatform()

    return {
      isIOS: platformName === 'ios',
      isAndroid: platformName === 'android',
      isWeb: platformName === 'web',
      isNative,
      platform: platformName,
    }
  }, [])
}
